export const MESSAGE_PROCESSING_STATUS_ID = 3;
export const MESSAGE_SENT_STATUS_ID = 0;
export const MESSAGE_DELIVERED_STATUS_ID = 1;
export const MESSAGE_SEEN_STATUS_ID = 2;
